import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Drop from "./pages/Drop";
import Cuidados from "./pages/Cuidados";
import "./styles/App.css";

function App() {
  return (
    <div className="App flex flex-col min-h-screen">
      <Header />
      <div className="flex-1 p-8" style={{ padding: "30px" }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Drop" element={<Drop />} />
          <Route path="/Cuidados" element={<Cuidados />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

export default App;
